import React from 'react';
import {Trans} from 'react-i18next';
import {CONSTANTS} from '../../../../../../Shared/Constants/Constants';
import {IssueProfile} from '../../../SensorIssueForm/IssueAlarmFormState';

type IssueAlarmMissingCommunicationWarningProps = {
	sensorIssuesForm: IssueProfile;
	show: boolean;
};

export default function IssueAlarmsMissingCommunicationWarningComponent(props: IssueAlarmMissingCommunicationWarningProps) {
	return (
		props.show && (
			<tr>
				<td>
					<Trans i18nKey={'sensorWizard.summary.missingCommunicationWarning'} />
				</td>
				<td>
					{(() => {
						if (props.sensorIssuesForm == null) {
							return CONSTANTS.NOT_AVAILABLE;
						}
						return props.sensorIssuesForm.missing_communication_warning ? CONSTANTS.YES : CONSTANTS.NO;
					})()}
				</td>
			</tr>
		)
	);
}
